import { gql } from '@apollo/client';
import { RelationalOperatorFragment } from '../fragments';

export const MeasureFilterFragment = gql`
  fragment MeasureFilterFields on MeasureFilter {
    relOp {
      ...RelationalOperatorFields
    }
    values
  }
  ${RelationalOperatorFragment}
`;

const SimpleMeasurePropertiesFragment = gql`
  fragment SimpleMeasurePropertiesFields on SimpleMeasureProperties {
    cohortRefs {
      ...CohortRefFields
    }
    filter {
      ...MeasureFilterFields
    }
  }
  ${MeasureFilterFragment}
`;

const CompoundMeasurePropertiesFragment = gql`
  fragment CompoundMeasurePropertiesFields on CompoundMeasureProperties {
    resultFilter {
      ...MeasureFilterFields
    }
    measures {
      ...SimpleMeasurePropertiesFields
    }
  }
  ${SimpleMeasurePropertiesFragment}
  ${MeasureFilterFragment}
`;

export const MeasurePropertiesFragment = gql`
  fragment MeasurePropertiesFields on MeasureProperties {
    ... on CompoundMeasureProperties {
      ...CompoundMeasurePropertiesFields
    }
    ... on SimpleMeasureProperties {
      ...SimpleMeasurePropertiesFields
    }
  }
  ${CompoundMeasurePropertiesFragment}
  ${SimpleMeasurePropertiesFragment}
`;
